<template>
    <div>

        <TextBanner>
            <p>Matthias Maurer ist der erste deutsche Astronaut, der mit dem privaten US-Unternehmen SpaceX ins All gestartet ist.</p>
            <p> <b>Drücken Sie auf den orangen Punkt und erfahren Sie, welche deutschen Astronauten bisher auf der ISS waren.</b></p>
        </TextBanner>

    <InfoBox modalName="Astronauten">
            <template #title>Deutsche Astronauten auf der ISS</template>
            <template #subline></template>
            <template>
                <p>Bisher waren vier Deutsche zum Leben und Arbeiten auf der Internationalen Raumstation.</p>

                <!-- FullscreenImage, lazyload -->
                <FullscreenImage :src="require('../assets/img/011_maurer.jpg')">
                    <figure>
                        <div class="lazy-container bg-dark">
                            <span class="zdf-load-icon"></span>
                            <!-- required (ratio): data-width, data-height -->
                            <img class="img-fluid" data-width="600" data-height="600" v-lazy="require('../assets/img/011_maurer_thumb.jpg')" alt="">
                        </div>
                        <figcaption>
                            <div class="legal">	&copy; dpa</div>
                            Der Saarländer <b>Matthias Maurer</b> lebte sechs Monate auf der ISS. Im Mai 2022 landete er im Meer vor der US-Ostküste. Er war an mehr als 100 Experimenten beteiligt und hatte auch einen Außeneinsatz.
                        </figcaption>
                    </figure>
                </FullscreenImage>

                <br>

                <!-- FullscreenImage, lazyload -->
                <FullscreenImage :src="require('../assets/img/011_reiter.jpg')">
                    <figure>
                        <div class="lazy-container bg-dark">
                            <span class="zdf-load-icon"></span>
                            <!-- required (ratio): data-width, data-height -->
                            <img class="img-fluid" data-width="600" data-height="600" v-lazy="require('../assets/img/011_reiter_thumb.jpg')" alt="">
                        </div>
                        <figcaption>
                            <div class="legal">&copy; dpa</div>
                            Als erster Deutscher reiste <b>Thomas Reiter</b> 2006 zur ISS. Seine zweite Reise zu einer Raumstation. Zuvor war er bereits als Esa-Astronaut zur russischen Raumstation Mir geflogen.
                        </figcaption>
                    </figure>
                </FullscreenImage>

                <br>

                <!-- FullscreenImage, lazyload -->
                <FullscreenImage :src="require('../assets/img/011_schlegel.jpg')">
                    <figure>
                        <div class="lazy-container bg-dark">
                            <span class="zdf-load-icon"></span>
                            <!-- required (ratio): data-width, data-height -->
                            <img class="img-fluid" data-width="600" data-height="425" v-lazy="require('../assets/img/011_schlegel_thumb.jpg')" alt="">
                        </div>
                        <figcaption>
                            <div class="legal">&copy; reuters</div>
                            2008 machte <b>Hans Schlegel</b> nur eine Stippvisite im All und brachte Europas Forschungsmodul Columbus zur Raumstation.

                        </figcaption>
                    </figure>
                </FullscreenImage>

                <br>

                <!-- FullscreenImage, lazyload -->
                <FullscreenImage :src="require('../assets/img/011_gerst.jpg')">
                    <figure>
                        <div class="lazy-container bg-dark">
                            <span class="zdf-load-icon"></span>
                            <!-- required (ratio): data-width, data-height -->
                            <img class="img-fluid" data-width="600" data-height="393" v-lazy="require('../assets/img/011_gerst_thumb.jpg')" alt="">
                        </div>
                        <figcaption>
                            <div class="legal">&copy; dpa</div>
                            <b>Alexander Gerst</b> reiste gleich zwei Mal für jeweils sechs Monate zur ISS: 2014 und 2018.                       
                        </figcaption>
                    </figure>
                </FullscreenImage>

            </template>
        </InfoBox>

        <!-- Fallback -->
        <Fallback>
            <picture>
                <source media="(orientation: portrait)" srcset="../assets/img/fallback/fallback_060_p.jpg">
                <source media="(orientation: landscape)" srcset="../assets/img/fallback/fallback_060_l.jpg">
                <!-- The img element is required as the last child tag of the picture declaration block. The img element is used to provide backward compatibility for browsers that do not support the picture element, or if none of the source tags matched. -->
                <img src="../assets/img/fallback/fallback.jpg" alt="">
            </picture>
            <div class="hotspot" v-on:click="infobox('Astronauten')"></div>
        </Fallback>


    </div>
</template>

<script>
    export default {
        name: 'infobox',
        babylonState: {
            camera: {
                position: [-8.2,.9,7.5],   //VÖ Stand 7.11.  -4.8,2,10           //-1.4,.6,11    //gut -8.2,.9,8.5     //schräg vorne .6,.9,18
                target: [.5,-1.5,5.8],    //VÖ Stand 7.11.  .5,-.5,4.7          //.5,-1.5,6.5     //gut .5,-1.5,6     //schräg vorne .5,-1.5,6
                animationSpeed: 450,  //450
                useAutoRotationBehavior: true,
                idleRotationSpeed: 0.02,  //-0.01
            },
            

            iss: {

                erde_pivot: {
                    erde: {
                        fade: true,
                        visible: true
                    },
                },

                Node_2:{
                pickable: false,
                },

                Columbus:{
                    pickable: false
                },

                Node_2_dock:{
                pickable: false,
                },

                ELM_Kibo:{
                pickable: false
                },

       
                SpaceX_Body: {
                    visible: true,
                    pickable: false,
                    // overlayColor: [20/255, 192/255, 216/255],
                    // overlayAlpha: 0.6,
                    SpaceX_Cargo: {
                        visible: true,
                        pickable: false,
                        // overlayColor: [20/255, 192/255, 216/255],
                        // overlayAlpha: 0.6,
                    },
                    SpaceX_Klappe: {
                        visible: true,
                        pickable: false,
                        // overlayColor: [20/255, 192/255, 216/255],
                        // overlayAlpha: 0.6,
                    }
                }

            },

            hotspots: {
                astronauten: {
                    visible: true,
                    infoBox: 'Astronauten',
                    position: [.55,.2,4.7],   //VÖ: .55,.2,4.7
                    scale: .8, //1.2          //VÖ: 1
                    renderingGroupId: 0
                }
            },
           
        },
        babylonReady: function () {
        this.$babylonController.timer.add(2200, () => {
            this.$babylonController.setCameraRadiusLimit(5,200);   //6,200
        });
        this.$babylonController.goToAnimation("spacex_anim", 0);
        this.$babylonController.startAnimation("spacex_anim", false, 0.2);  //0.3
        this.$babylonController.startAnimation("erde_pivot_anim", true, .01);   //.03
        //this.$audioController.initTrack('speaker', require('./../assets/audio/2496003_Starhorizon_192.mp3'), true, false);



        },
    }
</script>

<style scoped lang="scss">

    .fallback-container .hotspot {

        left: 30vw;
        top: 20vh;

        @media (orientation: landscape) {
            left: 50vw;
            top: 20vh;
            transform: scale(0.75);
        }
    }


</style>
